export default __webpack_public_path__ + "static/media/games.a8816d5b.txt";